import models from './models'
import menu from './menu'
import routes from './routes'

export default {

  name: 'Customers',

  setup () {
    return {
      menu,
      routes
    }
  },

  models () {
    return {
      'campaign': models.Campaign
    }
  }

}
